import styled from "styled-components"
import AddressIcon from "../common/assets/icons8-address.gif"
import AtSign from "../common/assets/icons8-at-sign.png"
import Phone from "../common/assets/icons8-ringer-volume.png"
import Footer from "../component/footer"
import { useEffect, useRef, useState } from "react"
import { useForm } from "@formcarry/react"

const ContactUsWrapper = styled.div`
    padding-top: 13vh;
    #contact-us{
        padding: 0 8vw;
        display: flex;
        min-height: 71vh;
        gap: 4vw;
        @media screen and (max-width: 800px){
            flex-direction: column-reverse;
            align-items: center;
            #contact-deatils{
                width: 90% !important;
                iframe{
                    width: 100%;
                    min-height: 300px;
                }
            }
        }
        form{
            width: 50%;
            display:flex;
            flex-direction: column;
            @media screen and (max-width: 800px){
                width: 90%;
            }
            input, textarea{
                font-size: 1.3rem;
                padding: 16px;
                outline: 0;
                margin-top: 24px;
                border-radius: 8px;
                border: 1px solid #000;
            }
            #response{
                margin-top: 24px;
                margin-bottom: 0;
            }
            .errorMessage{
                color: #a6192e;
            }    
            .successMessage{
                color: #5cb85c;
            }
            button{
                background: #053050;
                margin-top: 24px;
                padding: 16px;
                font-size: 1.3rem;
                color: #fff;
                font-weight: 550;
                border-radius: 8px;
                cursor: pointer;
            }
        }
        #contact-deatils{
            width: 50%;

            }
            .contact-info{
                display: flex;
                align-items: center;
                margin-top: 24px;
                
                img{
                    height: 45px;
                    }
                    
                .info{
                    font-size: 1.3rem;
                    margin-left: 24px;
                }
            }
    }
            #title{
            margin: 0;
            font-size: 2.5rem;
            font-weight: 600;
            color: #053050;
        } 
`

const ContactUs = () => {
    const formRef = useRef(null);
    const [response, setResponse] = useState({ message:"", error: false, serverResponse: false });
    const { state, submit } = useForm({
        id: 'D3OE4FxZLpn',
    });

    useEffect(() => {
        if (state?.response) {
            formRef.current.reset();
            setResponse({message:'Thank you! We received your submission', error: false, serverResponse: true});
            const timerId = setTimeout(() => {
                setResponse({ message:"", error: false, serverResponse: false });
            }, 3000);
            return () => clearTimeout(timerId);
        }
        if (state?.error) {
            setResponse({message:'Error Submitting Form', error: true, serverResponse: true});
            const timerId = setTimeout(() => {
                setResponse({ message:"", error: false, serverResponse: false });
            }, 3000);
            return () => clearTimeout(timerId);
        }
    }, [state?.error, state?.response]);
    return (
        <ContactUsWrapper>
            <div id="contact-us">
                <div id="contact-deatils">
                    <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d506.748341848413!2d85.31824476813252!3d27.75368047337461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb1ed49fb39337%3A0x1b4830cc358cf8ef!2sMahadevthan%20(Dhaneshwor%20Mandir)!5e1!3m2!1sen!2snp!4v1764863131669!5m2!1sen!2snp" width="100%" height="100%" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                </div>
                <form onSubmit={submit} ref={formRef}>
                    <p id="title">
                        Send Message
                    </p>
                    <input type="text" name="FullName" placeholder="Full Name" />
                    <input type="email" name="Email" placeholder="Email" />
                    <textarea type="text" name="Message" placeholder="Your Message" />
                    {response.serverResponse && <p id="response" className={response.error ? "errorMessage" : "successMessage"}>{response.message}</p>}
                    <button>Send</button>
                    <div className="contact-info">
                        <img src={AddressIcon} alt="address" />
                        <span className="info">Dhaneshwor, Tokha, Kathmandu, Nepal</span>
                    </div>
                    <div className="contact-info">
                        <img src={Phone} alt="address" />
                        <span className="info">+9779851110330</span>
                    </div>
                    <div className="contact-info">
                        <img src={Phone} alt="address" />
                        <span className="info">+9779843247614</span>
                    </div>
                    <div className="contact-info">
                        <img src={AtSign} alt="address" />
                        <span className="info">ainbhawani@gmail.com</span>
                    </div>
                </form>
            </div>
            <Footer />
        </ContactUsWrapper>
    )
}

export default ContactUs;